import React from 'react'
import {compose } from 'recompose'
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
//import _ from 'lodash'
import Button from '@material-ui/core/Button'
import {handleConnectCanidate} from '../../../../actions/adminCanidates'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit,
      },
      rowContent: {
        marginBottom: '0.8em',
        padding: '0.2em',
        borderBottom: '2px solid #3f51b5',
        
    },
})


const CanidateDetails = (props) => {
    const { classes, canidate, currentAdmin } = props
    
    const connectCanidate = () => {
        const { currentOpenEvent, history } = props

        const connectData = {
            canidateId: canidate.id,
            canidateName: canidate.name,
            adminId: currentAdmin.id,
            adminName: currentAdmin.name,
            requesterId: currentOpenEvent.event.userId,
            requesterName: currentOpenEvent.requester.name,
            event: currentOpenEvent.event,
            canidatesOnWait: currentOpenEvent.canidates
            
        }
        handleConnectCanidate(connectData)
        history.push('ADMINEVENTS')
        props.dispatchTogglePopUp(true)
    }
    return (
        <Paper className={classes.paper}>
            <Typography variant="headline" color='primary' gutterBottom>
                    Helfer Kontaktdaten
            </Typography>
            {canidate
                ?<div>
                    <Typography variant='subheading'>
                        <div  className={classes.rowContent}>{canidate.name}</div>
                        <div  className={classes.rowContent}>{canidate.strasse}</div>
                        <div  className={classes.rowContent}>{canidate.ort}</div>
                        <div  className={classes.rowContent}>{canidate.email}</div>
                        <div  className={classes.rowContent}>{canidate.telefon}</div>
                    </Typography>
                    <div>
                    <Button 
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={()=>connectCanidate()}
                        size="small"
                        fullWidth
                    >
                        Vermitteln
                    </Button>
                    </div>
                </div>
                : <div  className={classes.rowContent}> Wählen Sie einen Bewerber</div>
            }
        </Paper>)
}


const mapStateToProps = (state) => ({
    currentAdmin: state.userState.profile,
    canidate: state.adminCanidateState.selectedCanidate,
    currentOpenEvent: state.adminCanidateState.currentOpenEvent
})

const mapDispatchToProps = (dispatch) => ({
    dispatchTogglePopUp: (boolean)=>dispatch({type: 'IN_APP_NOTIFICATION', payload: boolean})
})


export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(CanidateDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminEventDetails/CanidateDetails.js